<template>
  <div>
    <el-card
      shadow="never"
      :body-style="{
        padding: '20px 15px',
      }"
    >
      <div v-if="!isEmpty">
        <Timeline>
          <TimelineItem
            v-for="(item, index) in quotationData"
            :key="index"
            v-bind="item"
          >
            <template #default="{ item }">
              <div class="quotation__container">
                <div class="product-descriptions__container mt-2">
                  <div class="row__container">
                    <div class="various">
                      <div class="various_label">
                        {{ $l('various_label_sample_name') || '产品名称' }}
                      </div>
                      <div class="various_value flex-1">
                        {{ item.content.quotationSampleName }}
                      </div>
                    </div>

                    <div class="various flex-none">
                      <div class="various_label">
                        {{ $l('various_label_trackingMethod') || '报价方式' }}
                      </div>
                      <div class="various_value flex-none w-140">
                        {{ item.content.v_trackingMethod }}
                      </div>
                    </div>

                    <div class="various flex-none">
                      <div class="various_label">
                        {{
                          $l('various_label_trackingCurrencyUnit') || '货币单位'
                        }}
                      </div>
                      <div class="various_value flex-none w-140">
                        {{ item.content.v_trackingCurrencyUnit }}
                      </div>
                    </div>
                  </div>
                  <div class="row__container">
                    <div class="various">
                      <div class="various_label">
                        {{ $l('various_label_scmName') || '成品工厂' }}
                      </div>
                      <div class="various_value flex-1">
                        {{ item.content.scmName }}
                      </div>
                    </div>

                    <div class="various flex-none">
                      <div class="various_label">
                        {{ $l('various_label_production_cycle') || '生产周期' }}
                      </div>
                      <div class="various_value flex-none w-140"></div>
                    </div>

                    <div class="various flex-none">
                      <div class="various_label">
                        {{ $l('various_label_ftyPrice') || '工厂报价' }}
                      </div>
                      <div class="various_value flex-none w-140">
                        {{ item.content.ftyPrice }}
                        {{ item.content.ftyCurrencyUnit }}
                      </div>
                    </div>
                  </div>
                  <div class="row__container">
                    <div class="various">
                      <div class="various_label">
                        {{ $l('various_label_fabricContent') || '面料规格' }}
                      </div>
                      <div class="various_value flex-1">
                        <span style="white-space: break-spaces">
                          {{ item.content.fabricContent }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="quotation__table">
                  <vxe-grid
                    ref="table"
                    auto-resize
                    highlight-hover-row
                    :data="item.content.listSample"
                    :columns="tableColumns"
                    :loading="loading"
                    size="small"
                    cell-class-name="align-top"
                    resizable
                    border="inner"
                    :seq-config="{
                      startIndex: 0,
                    }"
                  >
                    <template v-slot:quotationMoq="{ row }">
                      <span
                        >{{ row.quotationMoq }} 
                        {{ row.quotationMoqUnitText || '' }}</span
                      >
                    </template>
                  </vxe-grid>
                </div>
              </div>
            </template>
          </TimelineItem>
        </Timeline>
      </div>
      <div v-else class="not-data__container">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import Timeline from '../timeline/index.vue'
import TimelineItem from '../timeline/item.vue'
export default {
  props: {
    devTrackingCode: { type: String, default: '' },
  },
  components: { Timeline, TimelineItem },
  mounted() {
    this.getData()
  },
  data() {
    return {
      quotationData: [],
      loading: false,
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    isEmpty() {
      return !this.quotationData || !this.quotationData.length
    },
  },

  methods: {
    getData() {
      if (!this.devTrackingCode) return
      this.loading = true
      this.$api
        .masterCustomerDevQuotationVersionListApi({
          devTrackingCode: this.devTrackingCode,
        })
        .then((res) => {
          this.loading = false
          const list = res.body.data || []

          this.quotationData = list.map((m) => {
            m.type = 'O'
            m.title = `第${m.versionNo}轮：产品报价`
            m.time = m.createDate
            m.name = m.createByName
            m.content = { ...m }
            return m
          })
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.w-140 {
  width: 140px;
}
.flex-none {
  flex: none !important;
}
.flex-1 {
  flex: 1;
}
.product-descriptions__container {
  display: flex;
  flex-direction: column;
  border: 1px solid #efefef;
  border-bottom: none;
  .row__container {
    border-bottom: 1px solid #efefef;
    display: flex;
    .various {
      display: flex;
      flex: 1;
      align-items: center;
      .various_label {
        padding: 10px 10px;
        width: 100px;
        height: 100%;
        background-color: #fafafa;
        color: #999a9f;
        font-size: 13px;
        display: flex;
        border-right: 1px solid #efefef;
      }
      .various_value::-webkit-scrollbar {
        display: none;
      }
      .various_value {
        height: 100%;
        overflow: -moz-scrollbars-none;
        padding: 10px 10px;
        display: flex;
        align-items: center;
        flex: 1;
        font-size: 13px;
        color: #4f4f4f;
        align-content: center;
        border-right: 1px solid #efefef;
        overflow: scroll;
        -ms-overflow-style: none;
      }
    }
    > .various:last-child {
      .various_value {
        border-right: none;
      }
    }
  }
  > .row__container:last-child {
    border-bottom: none;
  }
}
.quotation__table {
  border: 1px solid #efefef;
  border-bottom: none;
}
.quotation__container {
  padding-bottom: 20px;
}
.not-data__container {
  height: 500px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
